import { Token } from "@siteimprove/alfa-css";
import { Device } from "@siteimprove/alfa-device";
import { Parser } from "@siteimprove/alfa-parser";
const { map } = Parser;
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#media-types}
 *
 * @public
 */
export class Type {
    static of(name) {
        return new Type(name);
    }
    _name;
    constructor(name) {
        this._name = name;
    }
    get name() {
        return this._name;
    }
    matches(device) {
        switch (this._name) {
            case "screen":
                return device.type === Device.Type.Screen;
            case "print":
                return device.type === Device.Type.Print;
            case "speech":
                return device.type === Device.Type.Speech;
            case "all":
                return true;
            default:
                return false;
        }
    }
    *iterator() {
        yield this;
    }
    [Symbol.iterator]() {
        return this.iterator();
    }
    equals(value) {
        return value instanceof Type && value._name === this._name;
    }
    toJSON() {
        return {
            name: this._name,
        };
    }
    toString() {
        return this._name;
    }
}
(function (Type) {
    function isType(value) {
        return value instanceof Type;
    }
    Type.isType = isType;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-type}
     */
    Type.parse = map(Token.parseIdent((ident) => {
        switch (ident.value) {
            // These values are not allowed as media types.
            case "only":
            case "not":
            case "and":
            case "or":
                return false;
            default:
                return true;
        }
    }), (ident) => Type.of(ident.value));
})(Type || (Type = {}));
//# sourceMappingURL=type.js.map